import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { url } from "../../../Constant";
import axios from "axios";
import { useAuth } from "../../../Context/AuthProvider";
import { toast } from "react-toastify";
import { ValidateEmail } from "../../../Utils/regexFunctions";

const AddUser = () => {
  const { auth } = useAuth();
  const [pages, setPages] = useState();
  const [loader, setLoader] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [errorEnable, setErrorEnable] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [pwdPassword, setPwdPassword] = useState("valid");
  const [submittedData, setSubmittedData] = useState({
    name: "",
    email: "",
    password: "",
    password_confirm: "",
  });

  const handleConfirmPwdValidation = (e) => {
    if (e === submittedData.password && e.length >= 5) {
      setPwdPassword(true);
    } else {
      setPwdPassword(false);
    }
  };
  const handlePasswordValidation = (e) => {
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{1,}$/;
    let testedPassword = passwordRegex.test(e);
    if (testedPassword === false) {
      setPasswordError("Validation error");
    } else if (e.length < 14) {
      setPasswordError("Invalid password");
    } else {
      setPasswordError("");
    }

    // if(submittedData.password_confirm==='')
  };

  const getPages = () => {
    axios
      .post(
        url + "pages",
        {},
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then((response) => {
        // console.log(response);
        if (response.data.code === 200) {
          const updatePages = response.data.data.map((element) => ({
            ...element,
            read_only: 0,
            read_and_write: 0,
          }));
          // console.log(updatePages);
          setPages(updatePages);
        }
      })
      .catch((error) => {
        console.log(error);
        // Handle other errors (e.g., network errors)
      })
      .finally(() => {
        // setLoader(false);
      });
  };

  useEffect(() => {
    getPages();
  }, []);

  const handleChangeRoleToggle = (rights, index, onOff) => {
    var tempData = [...pages];
    tempData[index][rights] = onOff;
    // console.log(tempData);
    setPages(tempData);
  };

  // const addUserRole = ()=>{
  //   // "vpbx_id": "6536809023c34",
  //   // "name": "Rahul",
  //   // "email": "Test@convex.com",
  //   // "password": "Testing@123456",
  //   // "password_confirm": "Testing@123456",

  // }

  const handleEmailValidation = (e) => {
    var Email = ValidateEmail(e);
    if (Email === "Invalid Email") {
      setEmailError("Invalid Email Address");
    } else {
      setEmailError("Valid Email Address");
    }
  };

  const addUserRole = (e) => {
    e.preventDefault();
    setLoader(true);
    setErrorEnable(true);

    if (
      submittedData.name !== "" &&
      submittedData.email !== "" &&
      submittedData.password !== "" &&
      submittedData.password_confirm !== "" &&
      pwdPassword === true &&
      passwordError === "" &&
      emailError === "Valid Email Address"
    ) {
      axios
        .post(
          url + "create-user",
          {
            vpbx_id: auth.vpbx_id,
            name: submittedData.name,
            email: submittedData.email,
            password: submittedData.password,
            password_confirm: submittedData.password_confirm,
            role_permissions: pages,
          },
          {
            headers: {
              Authorization: `Bearer ${auth.token}`,
            },
          }
        )
        .then(
          (response) => {
            // console.log(response);
            if (response.data.code === 200) {
              setLoader(false);
              // setApicalled(true);
              toast.success("User role added successfully", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 1500,
              });
              setTimeout(() => {
                // closeModal();
              }, 1000);
            } else {
              setLoader(false);

              if (response.data.data.hasOwnProperty("email") === true) {
                response.data.data.email.map((val, index) => {
                  return toast.error(val, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 1500,
                  });
                });
              } else {
                toast.error(response?.data?.message, {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 1500,
                });
              }
            }
          },
          (error) => {
            console.log(error);
          }
        );
    } else {
      setLoader(false);
    }
  };
  return (
    <div className="dashboardWrp">
      <div className="uk-container uk-container-small">
        <div className="dashboardTop">
          <div uk-grid="" className="uk-grid uk-grid-small">
            <div className="uk-width-2-3">
              <div className="dashboardIntro">
                <Link to="/user">
                  <img src="./assets/images/zong/chevron--left.svg" uk-svg="" />
                  <span>Back to all Users</span>
                </Link>
                <h3>CREATE USER ROLE</h3>
                {/* <p>You can add up to 10 users below by entering their phone or email addresses.</p> */}
              </div>
            </div>
          </div>

          <form action="javascript:void(0);">
            <div className="formCreateMain">
              <div className="uk-grid uk-grid-small">
                <div className="uk-width-1-1@m uk-margin-top">
                  <legend className="uk-legend">User information</legend>
                </div>
                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Name</label>
                  <input
                    className="uk-input"
                    type="text"
                    placeholder="please enter name"
                    aria-label="Input"
                    value={submittedData.name}
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        name: e.target.value,
                      });
                    }}
                  />
                  {errorEnable && submittedData.name === "" && (
                    <div className="formErrors">Name is required</div>
                  )}
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Email</label>
                  <input
                    className="uk-input"
                    type="text"
                    placeholder="Email address"
                    aria-label="Input"
                    value={submittedData.email}
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        email: e.target.value,
                      });
                      handleEmailValidation(e.target.value);
                    }}
                  />
                  {errorEnable && submittedData.email === "" && (
                    <div className="formErrors">Email is required</div>
                  )}
                  {submittedData.email !== "" &&
                    errorEnable &&
                    emailError !== "Valid Email Address" && (
                      <div className="formErrors">Invalid Email Address</div>
                    )}
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Password</label>
                  <input
                    className="uk-input"
                    type="password"
                    placeholder="please enter password"
                    aria-label="Input"
                    value={submittedData.password}
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        password: e.target.value,
                      });
                      handlePasswordValidation(e.target.value);
                    }}
                  />
                  {errorEnable && submittedData.password === "" && (
                    <div className="formErrors">Password is required</div>
                  )}
                  {submittedData.password !== "" &&
                    errorEnable &&
                    passwordError === "Invalid password" && (
                      <div className="formErrors">
                        password must be 14 characters
                      </div>
                    )}
                  {submittedData.password !== "" &&
                    errorEnable &&
                    passwordError === "Validation error" && (
                      <div className="formErrors">
                        password must includes uppercase, lowercase, numbers and
                        special characters
                      </div>
                    )}
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Confirm password</label>
                  <input
                    className="uk-input"
                    type="password"
                    placeholder="please enter confirm password"
                    aria-label="Input"
                    value={submittedData.password_confirm}
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        password_confirm: e.target.value,
                      });
                      handleConfirmPwdValidation(e.target.value);
                    }}
                  />
                  {errorEnable && submittedData.password_confirm === "" && (
                    <div className="formErrors">
                      Confirm Password is required
                    </div>
                  )}
                  {submittedData.password_confirm !== "" &&
                    errorEnable &&
                    pwdPassword === false && (
                      <div className="formErrors">
                        password and confirm password not matched{" "}
                      </div>
                    )}
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Pages</label>
                </div>
                <div className="uk-width-1-4@m uk-margin-top">
                  <label>Read Only</label>
                </div>
                <div className="uk-width-1-4@m uk-margin-top">
                  <label>Read/Write</label>
                </div>

                {pages?.map((val, index) => {
                  return (
                    <>
                      <div className="uk-width-1-2@m uk-margin-top">
                        <label>{val.page_name}</label>
                      </div>
                      <div className="uk-width-1-4@m uk-margin-top">
                        <span className="switchToggle">
                          <input
                            type="checkbox"
                            checked={val.read_only === 1 ? true : false}
                            onChange={() =>
                              handleChangeRoleToggle(
                                "read_only",
                                index,
                                val.read_only === 1 ? 0 : 1
                              )
                            }
                          />
                        </span>
                      </div>
                      <div className="uk-width-1-4@m uk-margin-top">
                        <span className="switchToggle">
                          <input
                            type="checkbox"
                            checked={val.read_and_write === 1 ? true : false}
                            onChange={() =>
                              handleChangeRoleToggle(
                                "read_and_write",
                                index,
                                val.read_and_write === 1 ? 0 : 1
                              )
                            }
                          />
                        </span>
                      </div>
                    </>
                  );
                })}
                {/* <div className="uk-width-1-2@m uk-margin-top">
                  <label>Admin Role</label>
                </div>
                <div className="uk-width-1-4@m uk-margin-top">
                  <span className="switchToggle">
                    <input type="checkbox" />
                  </span>
                </div>
                <div className="uk-width-1-4@m uk-margin-top">
                  <span className="switchToggle">
                    <input type="checkbox" />
                  </span>
                </div> */}

                <div className="uk-width-1-1@m uk-float-right">
                  <div className="formActionBtn uk-text-right">
                    <button className="whiteBtn">Cancel</button>
                    <button className="pinkBtn" onClick={addUserRole}>
                      {loader ? (
                        <div uk-spinner="" className="loader">
                          Adding
                        </div>
                      ) : (
                        " Add User"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddUser;
